import { render, staticRenderFns } from "./RelatedDeliverablesSocialMediaSchedule.vue?vue&type=template&id=35c43488&"
import script from "./RelatedDeliverablesSocialMediaSchedule.vue?vue&type=script&lang=js&"
export * from "./RelatedDeliverablesSocialMediaSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c43488')) {
      api.createRecord('35c43488', component.options)
    } else {
      api.reload('35c43488', component.options)
    }
    module.hot.accept("./RelatedDeliverablesSocialMediaSchedule.vue?vue&type=template&id=35c43488&", function () {
      api.rerender('35c43488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/RelatedDeliverablesSocialMediaSchedule.vue"
export default component.exports